exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-input[data-v-4f6993ea]{border:none;padding-right:0}.drop-panel[data-v-4f6993ea]{transform:translateX(-50%);left:50%;padding:1rem;width:750px;z-index:10}.drop-panel.month-picker[data-v-4f6993ea]{width:350px}.is-empty[data-v-4f6993ea]{color:var(--black-light-3)}.drop-panel[data-v-4f6993ea]{max-width:100%;min-width:300px}.drop-panel[data-v-4f6993ea] .dp-calender-header,.drop-panel[data-v-4f6993ea] .dp-grid{column-gap:0}", ""]);

// exports
